import type React from 'react';

import MarkdownComponent from 'containers/user/learn/components/markdown/markdown';

import { MARKDOWN_OVERRIDES } from 'containers/admin/clients/client/tabs-components/ai-assistant/ai-assistant.constants';

export interface TextPartProps {
  data: { text?: string };
}

const TextPart = ({ data }: TextPartProps): React.JSX.Element => (
  <MarkdownComponent
    customClass="whitespace-pre-wrap break-words"
    text={data?.text ?? ''}
    overrides={MARKDOWN_OVERRIDES}
  />
);

export default TextPart;
